import { Routes } from '@angular/router';
import { routePaths } from './constants';
import { HomePage } from './pages/home/home.page';
import { SsotokenGuard } from './guards/sso-token.guard';
import { configResolver } from './core/resolvers/config.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  // {
  //   path: 'login', // New route to match /login
  //   canActivate: [SsotokenGuard],
  //   redirectTo: 'app/#/login',
  //   pathMatch: 'full',    
  // },
  {
    path: routePaths.login,
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage),
    resolve: {
      orgConfig: configResolver
    }
  },
  {
      path: 'dashboard',
      redirectTo: 'app/#/dashboard',
      pathMatch: 'full',   
  },
  // {
  //   path: 'app',
  //   redirectTo: '', 
  // },
  // {
  //   path: 'app/login',
  //   redirectTo: 'login',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    canActivate: [SsotokenGuard],
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage)
  },
  {
    path: routePaths.ira,
    loadComponent: () => import('./pages/ira/ira.page').then( m => m.IRAPage)
  },
  {
    path: routePaths.helpCenter,
    loadComponent: () => import('./pages/help-center/help-center.page').then( m => m.HelpCenterPage)
  },
  {
    path: routePaths.automated,
    loadComponent: () => import('./pages/automated/automated.page').then( m => m.AutomatedPage)
  },
  {
    path: routePaths.selfDirected,
    loadComponent: () => import('./pages/self-directed/self-directed.page').then( m => m.SelfDirectedPage)
  },
  {
    path: routePaths.individualJoint,
    loadComponent: () => import('./pages/individual-joint/individual-joint.page').then( m => m.IndividualJointPage)
  },
  {
    path: routePaths.custodial,
    loadComponent: () => import('./pages/custodial/custodial.page').then( m => m.CustodialPage)
  },
  {
    path: routePaths.contact,
    loadComponent: () => import('./pages/contact/contact.page').then( m => m.ContactPage)
  },
  {
    path: routePaths.educationCenter,
    loadComponent: () => import('./pages/education-center/education-center.page').then( m => m.EducationCenterPage)
  },
  { 
    path: '**', 
    redirectTo: '' 
  }
];
